import { gql } from '@apollo/client'

export const GET_KNOWLEDGE_BASE = gql`
  query GetKnowledgeBase($voiceAgentId: String!) {
    knowledgeBase(voiceAgentId: $voiceAgentId) {
      name
      text
    }
  }
`

export const UPDATE_KNOWLEDGE_BASE = gql`
  mutation UpdateKnowledgeBase($input: UpdateKnowledgeBaseInput!) {
    updateKnowledgeBase(input: $input) {
      name
      text
    }
  }
`

export const CREATE_KNOWLEDGE_BASE = gql`
  mutation CreateKnowledgeBase($input: CreateKnowledgeBaseInput!) {
    createKnowledgeBase(input: $input) {
      name
      text
    }
  }
`
